import { render, staticRenderFns } from "./detail-component-person.vue?vue&type=template&id=0b280100&scoped=true"
import script from "./detail-component-person.vue?vue&type=script&lang=ts"
export * from "./detail-component-person.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b280100",
  null
  
)

export default component.exports